import { FC } from "react";
import { OutlineBadge, OutlineBadgeColor } from "@app/shared/OutlineBadge";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { ZIP_POINTS_INFO } from "@app/shared/mapping/zipPoints";

interface ZipPointBadgeProps {
  className?: string;
  testId?: string;
}

export const ZipPointBadge: FC<ZipPointBadgeProps> = ({ className, testId }) => (
  <TooltipWrapper text={ZIP_POINTS_INFO} position="left" tooltipWidth="20rem">
    <OutlineBadge className={className} color={OutlineBadgeColor.Gray} testId={testId}>
      Zip Point
    </OutlineBadge>
  </TooltipWrapper>
);
